<template>
    <div id="header">
        <div class="header-wrap" :style="{backgroundColor: configInfo.style}">
            <div class="logo-wrap" @click="goHome">
                <!--<img :src="logo"/>-->
                <img v-if="configInfo.areaLogo" :src="configInfo.areaLogo | imgUrl(8)"/>
            </div>
            <div class="title f16" :title="configInfo.areaTitle">
                <span>{{configInfo.areaTitle}}</span>
            </div>
            <div class="headerMenu" id="vocHeader">
                <el-menu :default-active="activeIndex"
                         :background-color='configInfo.style'
                         text-color="#ffffff"
                         active-text-color="#fff"
                         :style="{borderBottom: configInfo.style }"
                         class="el-menu-demo" mode="horizontal"
                         :collapseTransition="false"
                >
                    <tl-sub-menu
                            v-for="menu in routerList"
                            :key="menu.id +''"
                            :menu="menu"
                    >
                    </tl-sub-menu>
                </el-menu>
            </div>

            <div class="user-state" v-if="roleList.list && roleList.list.length>1">
                <el-select v-model="roleId" size="mini" placeholder="请选择" style="width: 80px" @change="roleChange">
                    <el-option
                            v-for="item in roleList.list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>

            <div class="user-state" v-if="cityList.length>1">
                <el-select v-model="cityCode" size="mini" placeholder="请选择" style="width: 80px" @change="cityChange">
                    <el-option
                            v-for="item in cityList"
                            :key="item.cityCode"
                            :label="item.city"
                            :value="item.cityCode">
                    </el-option>
                </el-select>
            </div>
            <div class="user-state">
                <div
                        v-if="!userName"
                        class="nologin-text"
                        @click="showLogin = true"
                >
                    登录
                </div>
                <div v-else class="login-text">
                    <a-dropdown>
                        <div class="login-out-wrap ant-dropdown-link" :title="userName">
                            <span class="login">欢迎您，{{userName}}</span>
                        </div>
                        <a-menu slot="overlay">
                            <a-menu-item key="0">
                                <router-link class="login-info-btn" to="/home/personal">个人信息</router-link>
                            </a-menu-item>
                            <a-menu-item key="2">
                                <div @click="systemChange">
                                    系统切换
                                </div>
                            </a-menu-item>
                            <a-menu-item key="1">
                                <span class="login-info-btn" @click="loginOut">退出登录</span>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </div>
            </div>

<!--            <div class="gps-position" @click="toSelectCity" v-if="userType===1">-->
<!--                <a-icon style="margin-right:8px;" type="environment"/>-->
<!--                <span v-if="gpsState.area && gpsState.area !== gpsState.city">{{gpsState.area}} <a-icon-->
<!--                        style="margin: 0 3px 0 3px;font-size:10px;" type="right"/> </span>-->
<!--                <span>{{gpsState.city}}</span>-->
<!--            </div>-->
        </div>
        <tags-view></tags-view>
        <Login
                v-if="showLogin"
                :showLogin.sync="showLogin"
        />
    </div>
</template>

<script>
    // import Steps from "@/components/Steps";
    import Login from "@/components/Login"
    import LogoImg from "@/assets/images/logo.png";
    import UrlApi from "@/utils/UrlApi.js";
    import Bus from "@/utils/EventBus.js";
    import Cookie from "js-cookie";
    import Mixins from "@/utils/Mixins.js";
    import tagsView from "../TagsView/dstIndex"
    import TlSubMenu from "./main-sidebar-sub-menu";


    export default {
        name: "Header",
        mixins: [Mixins],
        inject: ['reload'],
        data() {
            return {
                logo: LogoImg,
                current: [0],
                showLogin: false,
                cityList: [],
                roleList: {},

                settingMenu: [
                    // {menuId:"base",title:"基本设置"},
                    {menuId: "user", title: "用户管理"},
                ],
                configInfo: {},
                routerList: [],
                activeIndex: '',
                cityCode: '',
                roleId: '',
            };
        },
        props: {
            loading: Boolean
        },
        computed: {
            userType: {
                get() {
                    return this.$store.state.userType;
                },
                set(val) {
                    this.$store.commit("updateUserType", val);
                }
            },
            userId: {
                get() {
                    return this.$store.state.userId;
                },
                set(val) {
                    this.$store.commit("updateUserId", val);
                }
            },
            VOCTagsList: {
                get() {
                    return this.$store.state.DSTTagsList
                },
                set(val) {
                    this.$store.commit("updateDSTTagsList", val);
                }
            },
            userName: {
                get() {
                    return this.$store.state.userName
                }
            },
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            },
            showSetting() {
                let state = false;
                let adminUserIds = this.$store.state.adminUserIds;
                let userId = this.$store.getters.getUserId;
                if (adminUserIds.indexOf(userId) !== -1) {
                    state = true;
                }
                return state;
            },
            address: {
                get() {
                    return this.$store.state.address
                },
                set(val) {
                    this.$store.commit('updateAddress', val)
                }
            },  // 地址
            signature: {
                get() {
                    return this.$store.state.signature
                },
                set(val) {
                    this.$store.commit('updateSignature', val)
                }
            }, // 监制
            post: {
                get() {
                    return this.$store.state.post
                },
                set(val) {
                    this.$store.commit('updatePost', val)
                }
            },          //  邮编
        },
        components: {
            TlSubMenu,
            // Steps,
            Login,
            tagsView
        },
        created() {
            this.getMenuList()
            this.getCityList()
            this.getRoleList()
            this.getData();
            this.getConfigInfo()
            this.getUserInfo()
            Bus.$on('goBackToHome', () => {
                this.goHome();
            });
        },
        methods: {

            //  获取   城市检测/区域成因  菜单
            getData() {
                let url = UrlApi.cityList;
                // let gpsState = this.$store.getters.getGpsState;
                let params = Object.assign({}, this.gpsState);
                // params.userId = this.$store.getters.getUserId;
                let causeParams = Object.assign({}, params);
                causeParams.menuTypeId = 3;
                let cityParams = Object.assign({}, params);
                cityParams.menuTypeId = 2;

                let p1 = new Promise((resolve) => {
                    this.$http.get(url, {
                        params: causeParams
                    }).then(res => {
                        resolve(res);
                    })
                })
                let p2 = new Promise((resolve) => {
                    this.$http.get(url, {
                        params: cityParams
                    }).then(res => {
                        resolve(res);
                    })
                })
                Promise.all([p1, p2]).then((result) => {
                    this.initCauseAnalysisData(result[0]);
                    this.initCityList(result[1]);
                    this.initRouteParam();
                    this.$emit('update:loading', true);
                })
            },

            //  获取个性化设置
            getConfigInfo() {
                let url = UrlApi.configInfo
                this.$http.get(url, {
                    params: {}
                }).then(res => {
                    this.configInfo = res.data.data

                    this.address = res.data.data.address
                    this.signature = res.data.data.signature
                    this.post = res.data.data.post

                })
            },

            //  获取用户信息
            getUserInfo() {
                let url = UrlApi.GetUserInfo
                this.$http.get(url, {
                    params: {}
                }).then(res => {
                    console.log(res)
                    // window.localStorage.getItem('gpsState')
                    // this.userType = res.data.data.type
                    // this.userType = res.data.data.userInfo.roleId
                    this.userId = res.data.data.userId
                    this.cityCode = res.data.data.cityCode
                    this.gpsState = {
                        area: res.data.data.area,
                        city: res.data.data.city,
                        cityCode: res.data.data.cityCode
                    }

                })
            },

            // 初始城市监测Data
            initCityList(result) {
                let userName = this.$store.getters.getUserName;
                if (result.data.success && result.data.data && userName) {
                    this.$store.commit("updateCityListData", result.data.data);
                }
            },
            // 初始化成因分析Data
            initCauseAnalysisData(result) {
                this.$store.commit("updateCauseAnalysisData", result.data.data);
            },
            // 根据路由初始化
            initRouteParam() {
                // 首次加载无路由识别 -> 跳转成因分析 默认选中第一个
                if (!this.$route.name) {
                    this.goHome();
                    return
                }
                // 页面刷新通过menuId选中默认
                if (this.$route.name === "CauseAnalysis") {
                    let menuId = this.$route.params.menuId;
                    if (menuId) {
                        if (menuId.indexOf("-") !== -1) {
                            let [parentMenuId, secondDataId] = menuId.split("-");
                            this.current = [parentMenuId];
                            this.$store.commit("updateCauseAnalysisSelect", parentMenuId);
                            this.$store.commit("updateSecondSelectData", secondDataId)
                        } else {
                            this.current = [menuId];
                            this.$store.commit("updateCauseAnalysisSelect", menuId);
                        }
                    }
                    // 页面刷新通过details参数初始化
                    let detailsId = this.$route.query.detailsId;
                    if (detailsId) {
                        this.$store.commit("updateResourceDetailsData", detailsId)
                    }
                }
                else if (this.$route.name === "CityMonitor") {
                    let cityData = this.$store.getters.getCityListData;
                    if (!this.$store.getters.getUserName && !cityData.length) {
                        this.goHome();
                        return;
                    }
                    let menuId = this.$route.params.menuId;
                    if (menuId) {
                        this.current = ["cityListMenu-" + menuId];
                        this.$store.commit("updateCityListDataSelect", menuId);
                    }
                    // 页面刷新通过details参数初始化
                    let detailsId = this.$route.query.detailsId;
                    if (detailsId) {
                        this.$store.commit("updateResourceDetailsData", {
                            type: "CityMonitor",
                            menuId: detailsId
                        });
                    }
                }
                else if (this.$route.name === "AirQuality") {
                    this.current = ["airQuality"];
                }
                else if (this.$route.name === "Wind") {
                    this.current = ["wind"];
                }
                else if (this.$route.name === "AIChart") {
                    this.current = ["AIChart"];
                } else if (this.$route.name === "stateSite") {
                    this.current = ["stateSite"];
                } else if (this.$route.name === "provinceSite") {
                    this.current = ["provinceSite"];
                } else if (this.$route.name === "villagesSite") {
                    this.current = ["villagesSite"];
                }
                else {
                    let menuName = ["Personal", "ReportsList", "AnswerReports", "EditReport", "ViewReport", "CityMonitor", "SystemSetting", "BaseSetting", "UserSetting"];
                    let userName = this.$store.getters.getUserName;
                    if (menuName.indexOf(this.$route.name) !== -1 && !userName) {
                        this.goHome();
                    }
                }
            },

            // 登出
            loginOut() {
                let url = UrlApi.loginOut;
                let token = this.$store.getters.getToken;
                let userId = this.$store.getters.getUserId;
                this.$http.get(url, {
                    params: {
                        userId: userId
                    },
                    headers: {
                        'Authorization': token,
                        "Content-Type": "application/x-www-form-urlencoded"
                    }
                }).then((res) => {
                    let message = res.data.message;
                    if (res.data.success) {
                        this.$message.success(message);
                        Cookie.remove("BSG-userInfo");

                        localStorage.removeItem('token')
                        localStorage.removeItem('userName')
                        localStorage.removeItem('userType')


                        let isNewLoogin = localStorage.getItem('isNewLoogin')

                        if(isNewLoogin){
                            this.$router.replace({
                                name: 'Dlogin'
                            })
                        }else {
                            this.$router.replace({
                                name: 'login'
                            })
                        }

                        // this.$router.replace({
                        //     name: 'login'
                        // })

                        // let userInfo = {
                        //     userId: null,
                        //     token: null,
                        //     userName: null
                        // }


                        // this.upDateUserInfo(userInfo);
                        // this.getData();
                        // this.goHome();
                        return;
                    }
                    this.$message.error(message);
                })
            },
            // 返回首页
            goHome() {
                let data = this.$store.getters.getCauseAnalysisData[0];

                this.$store.commit("updateCauseAnalysisSelect", data.menuId);
                // this.$router.push("/cause-analysis/"+data.menuId);
                this.$router.push({
                    name: 'CauseAnalysis',
                    query: {id: data.menuId}
                });

                this.current = [String(data.menuId)];
            },


            getCityList() {
                let data = {}
                this.$http.get(UrlApi.roleCity, {
                    params: data
                }).then(res => {
                    this.cityList = res.data.data
                })
            },


            // 跳转到城市选择
            toSelectCity() {
                this.$store.commit("updateSaveRouter", this.$route);
                this.$router.push({
                    name: 'SelectCity'
                })
            },

            systemChange() {
                this.$router.push({name: 'systemSelection'})
            },


            //    获取菜单

            getMenuList() {
                let data = {
                    id: '1'
                }
                this.$http.get(UrlApi.sysMenuNav, {
                    params: data
                }).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        this.routerList = res.data.data.menuList
                        // console.log(JSON.stringify(this.routerList))
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  获取 角色

            getRoleList() {
                let data = {}
                this.$http.get(UrlApi.roleList, {
                    params: data
                }).then(res => {
                    this.roleList = res.data.data
                    this.roleId = res.data.data.roleId
                })
            },
            cityChange(value) {
                let self = this
                this.$confirm('是否确认切换城市(此操作将更新页面), 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let datas = {
                        cityCode: value
                    }
                    this.$http.post(UrlApi.setRoleCity, datas
                    ).then(({data}) => {
                            if (data.code === '200') {
                                this.VOCTagsList = []
                                this.getMenuNav()
                                // self.$router.replace({name: 'systemSelection'})

                            }
                        }
                    )
                }).catch(() => {
                    this.cityCode = this.gpsState.cityCode
                });
            },


            // 切换城市.获取当前可跳转页面
            getMenuNav() {
                let self = this
                let params = {}
                this.$http.get(UrlApi.getMenuNav, {params: params}
                ).then(({data}) => {
                        if (data.code === '200') {
                            // console.log(data)
                            let reponse = data.data
                            self.reload()

                            if (reponse.parentId === 1) {
                                this.$router.push({name: 'AirQuality'})
                                return
                            }


                            if (reponse.parentId === 2) {

                                this.$router.push({name: 'CityMonitor', query: {id: reponse.menuId}})

                                return
                            }

                            if (reponse.parentId === 3) {
                                this.$router.push({name: 'CauseAnalysis', query: {id: reponse.menuId}})
                                return
                            }

                        }
                    }
                )
            },

            roleChange(value) {
                let self = this
                this.$confirm('是否确认切换角色(此操作将更新页面), 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let datas = {
                        roleId: value
                    }
                    this.$http.post(UrlApi.setRole, datas
                    ).then(({data}) => {
                            if (data.code === '200') {
                                this.VOCTagsList = []
                                self.$router.replace({name: 'systemSelection'})
                                self.reload()
                            }
                        }
                    )
                }).catch(() => {
                    this.roleId = this.roleList.roleId
                });
            }
        }
    }

</script>
<style lang="less" scoped>
    @media (max-width: 1200px) {
        .title {
            display: none;
        }
    }

    .login-info-btn {
        display: block;
        width: 80px;
        height: 100%;
    }

    #header {
        width: 100%;
        .header-wrap {
            padding: 0 30px 0 30px;
            /*background-color: #2F639A;*/
            color: #f0f0f3;
            height: 50px;
            display: flex;
            align-items: center;
        }
        .logo-wrap {
            /*float: left;*/
            /*width: 28px;*/
            /*overflow: hidden;*/
            cursor: pointer;
            img {
                display: block;
                width: 28px;
                height: 28px;
                /*width: 100%;*/
                /*height: 100%;*/
            }
        }
        .title {
            line-height: 44px;
            padding-left: 20px;
            white-space: nowrap;
            /*overflow: hidden;*/
            text-overflow: ellipsis;
        }

        .gps-position {
            float: right;
            height: 100%;
            line-height: 44px;
            margin-right: 30px;
            cursor: pointer;
        }
        .user-state {
            .nologin-text {
                height: 100%;
                padding: 0px 10px;
                cursor: pointer;
                &:hover {
                    background: hsla(0, 0%, 100%, .16);
                }
            }
            .login-text {
                height: 100%;
                cursor: pointer;
                .login-out-wrap {
                    float: left;
                    height: 100%;
                    text-align: center;
                    position: relative;
                    top: 0px;
                    left: 0px;
                    min-width: 120px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    .login-out {
                        width: auto;
                        height: 0px;
                        white-space: nowrap;
                        word-break: break-all;
                        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                        position: absolute;
                        right: -10px;
                        top: 50px;
                        z-index: 1000;
                        background: #2F639A;
                        transition: 0.3s ease 0s;
                        -webkit-transition: 0.3s ease 0s;
                        overflow: hidden;
                        cursor: pointer;
                    }
                    &:hover .login-out {
                        height: 40px !important;
                    }
                }
                .login {
                    float: left;
                    color: #f0f0f3;
                    padding: 0px 10px;
                    height: 100%;
                    &:hover {
                        background: hsla(0, 0%, 100%, .16);
                    }
                }
            }
        }
        .headerMenu {
            flex: 1;
            /*min-width: 758px;*/
            margin-left: 10px;
        }
    }
</style>
<style lang="less">
    #header {
        .ant-menu {
            background-color: #2F639A;
            color: #f0f0f3;
        }
        .ant-menu-item, .ant-menu-submenu-title {
            padding: 0 10px;
        }
        .ant-menu-submenu > .ant-menu {
            background-color: #2F639A !important;
            color: hsla(0, 0%, 100%, .65);
        }
        .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
            background-color: #bfd9e1 !important;
            color: #bfd9e1;
        }
        .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-active {
            color: #ffffff;
        }
        .ant-menu-horizontal {
            border-bottom: none !important;
        }
        .ant-menu-item, .ant-menu-submenu-title {
            color: #ffffff;
        }
    }

</style>
